// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1RYPx","bigColWidth":"Table_bigColWidth__2LcJh","biggerColWidth":"Table_biggerColWidth__P-hHB","row":"Table_row__VYBjK","col":"Table_col__3whA4"};